module.exports = __webpack_public_path__ + "47b868ff10a1fe5eb18abac8ca9936d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/svg/facebook-square.svg
// module id = 1100
// module chunks = 0